import React from 'react'
import BumpScreen from './components/BumpScreen'

/**
 * Standalone page for Bump Screen without any layout wrapper (no nav, headers, etc.)
 */
const BumpScreenPage: React.FC = () => {
  return (
    <div style={{width: '100vw', height: '100vh', overflow: 'auto'}}>
      <BumpScreen />
    </div>
  )
}

export default BumpScreenPage
